import React from 'react'
import { getSvgIconUrl } from '../../parameters'
import { buildStyleAttributes, hexToCssFilter, hexToRgb } from '../utils/css'
import s from './MenuCategoryItem.less'

const MenuCategoryItem = ({ id, shortLabel, iconId, color, selected, active, onMouseOver, onCategoryClick }) => {
  const labelStyle = {}
  const iconStyle = {}

  if (selected) {
    iconStyle.borderColor = color
    iconStyle.backgroundColor = color
    labelStyle.color = color
  } else if (active) {
    iconStyle.borderColor = hexToRgb(color, 0.5)
    iconStyle.fill = color
  }
  const filter = selected ? 'invert(1)' : hexToCssFilter(color)

  return (
    <li key={id} className={s.category} onClick={onCategoryClick}>
      <div className={s.categoryItem}>
        <span className={s.categoryIcon} onMouseOver={onMouseOver} style={buildStyleAttributes(iconStyle)}>
          <img
            src={getSvgIconUrl(global.__SVG_TIMESTAMP__, iconId)}
            style={{ filter }}
            alt={iconId}
            width={20}
            height={20}
          />
        </span>
        <span className={s.categoryLabel} style={buildStyleAttributes(labelStyle)}>
          {shortLabel}
        </span>
      </div>
    </li>
  )
}

export default MenuCategoryItem
